import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "../store";

var lang = navigator.language || navigator.userLanguage;
if (lang == "fr" || lang.split("-")[0] == "fr") {
  // 'fr', 'fr-BE', ...
  lang = "fr";
} else {
  lang = "en";
}

Vue.use(VueI18n);

Vue.config.lang = lang;

export const i18n = {
  get: () => {
    const messages = store.state.admin.admin_i18n;

    return new VueI18n({
      locale: lang, // set locale
      fallbackLocale: lang,
      silentTranslationWarn: false,
      messages,
    });
  },
};
